module.exports = __webpack_public_path__ + "assets/three-dots-93dca0.svg";